import IMask from 'imask';

const PhoneMask = () => {
  const phoneInput = document.getElementById('phone');

  const maskOptions = {
    mask: '000-000-00'
  };
  
  if (phoneInput) {
    const phoneMask = IMask(phoneInput, maskOptions);
  }
}

export default PhoneMask